import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AuthGate } from './AuthGate'
import { ToastProvider } from './components/ToastProvider'
import { ErrorBoundary } from './components/ErrorBoundary'
import OfflineBanner from './components/OfflineBanner'
import { initAnalytics } from './analytics'
import './index.css'
import './App.css'
// ⬇️ NEW — must be imported AFTER index.css so its overrides win cascade order.
import './styles/cross-browser-fixes.css'

// Boot analytics (loads GA4 only if consent was previously granted)
initAnalytics();

// Apply dark mode immediately from localStorage so there's no flash
// (ProfileView persists this as pref_dark_mode)
const savedDarkMode = localStorage.getItem('pref_dark_mode');
document.documentElement.setAttribute(
  'data-theme',
  savedDarkMode === 'false' ? 'light' : 'dark',
);

// iOS Safari: add touchstart listener so the browser treats elements as "touchable"
// and fires click events immediately without waiting for double-tap
document.addEventListener('touchstart', () => {}, { passive: true });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <OfflineBanner />
      <ToastProvider>
        <AuthGate>
          <App />
        </AuthGate>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
